export const extras = [
  {
    id: 1,
    name: "Silla de bebé",
    price: 40,
    priceType: "fixed" // fixed price vs per day
  },
  {
    id: 2,
    name: "WC portátil",
    price: 15,
    priceType: "fixed"
  },
  {
    id: 3,
    name: "Kit menaje",
    description: "(cubiertos, platos, bowls, sartén, cazo, abridor y cucharón)",
    price: 30,
    priceType: "fixed"
  },
  {
    id: 4,
    name: "Kit dormir",
    description: "(sábanas, manta y 2 toalla de ducha)",
    price: 40,
    priceType: "fixed"
  }
]; 